var _defs, _rect, _path, _path2, _g, _g2, _line, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNeuroiq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "257 252 510 510",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rh",
    gradientUnits: "userSpaceOnUse",
    x1: 506,
    y1: 516,
    x2: 753,
    y2: 503
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0369A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0284C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lh",
    gradientUnits: "userSpaceOnUse",
    x1: 267,
    y1: 511,
    x2: 509,
    y2: 512
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1E3A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1D4ED8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ball-shade",
    cx: "36%",
    cy: "30%",
    r: "65%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "38%",
    stopColor: "#ecf5f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#aecede"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dimple-shade",
    cx: "35%",
    cy: "30%",
    r: "70%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#93b8ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#c2dae5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ball-shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 5,
    stdDeviation: 14,
    floodColor: "#0b1c55",
    floodOpacity: 0.42
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    fill: "#FFFFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rh)",
    d: "M560.369 277.172C594.606 260.691 640.283 289.117 649.817 323.43C650.727 325.509 651.42 327.216 652.186 329.352C670.558 332.398 690.142 346.326 700.622 361.498C714.411 381.459 717.433 398.355 715.184 421.883C741.434 449.235 749.904 476.708 739.628 513.819C753.7 532.435 759.58 554.028 756.321 577.223C753.198 600.478 740.773 621.471 721.89 635.398C717.52 638.681 713.291 640.972 708.507 643.563C706.909 670.747 700.395 688.225 679.508 707.253C675.214 711.164 663.285 718.737 658.065 719.76C653.52 721.896 646.995 723.424 642.052 724.746C623.823 746.045 608.689 753.096 580.501 752.076C568.777 750.653 562.088 748.657 551.581 742.853C535.072 733.788 522.953 718.406 518 700.235C514.077 686.25 514.978 670.371 514.927 655.75L514.789 617.695L514.863 465.207L514.862 384.97C514.858 349.213 510.267 313.807 541.092 288.786C546.553 284.354 553.514 279.055 560.369 277.172Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lh)",
    d: "M425.397 274.572C433.005 273.105 439.827 272.15 447.495 273.209C479.474 277.626 502.56 302.656 507.699 333.985C509.295 343.711 509.109 352.151 509.19 361.944L509.385 393.075L509.489 506.505L509.528 626.101L509.489 661.973C509.479 669.013 509.724 678.393 508.987 685.235C507.682 697.66 503.342 709.574 496.35 719.928C479.385 744.601 447.166 759.017 417.832 749.717C402.874 745.134 391.395 737.033 382.522 723.987C363.182 719.858 349.636 714.411 336.027 699.231C322.453 684.278 315.386 664.54 316.383 644.37C310.97 640.953 305.014 637.814 299.88 633.938C285.231 622.877 274.162 605.319 269.778 587.517C265.235 569.072 266.675 547.073 274.933 529.83C277.775 523.895 281.594 519.162 284.902 513.654C282.225 499.808 280.64 491.759 282.028 477.085C284.002 456.207 294.213 435.348 310.566 421.961C305.414 377.208 330.01 339.171 374.189 328.343C381.914 301.163 398.245 283.157 425.397 274.572Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "rgba(255,255,255,0.22)",
    strokeWidth: 5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 572,288 C 578,312 600,346 628,378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 628,325 C 648,358 668,398 672,442"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 700,430 C 714,468 720,508 714,548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 718,492 C 714,534 700,572 682,608"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672,622 C 656,652 634,676 606,698"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 620,690 C 604,712 578,730 550,740"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "rgba(255,255,255,0.22)",
    strokeWidth: 5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 452,285 C 446,309 424,343 396,375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396,322 C 376,355 356,395 352,439"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 324,428 C 310,466 304,506 310,546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 306,490 C 310,532 324,570 342,606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 352,620 C 368,650 390,674 418,696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 404,688 C 420,710 446,728 474,738"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 512,
    y1: 278,
    x2: 512,
    y2: 752,
    stroke: "rgba(255,255,255,0.28)",
    strokeWidth: 3.5
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ball-shadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 538,
    r: 105,
    fill: "url(#ball-shade)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 538,
    r: 9.5,
    fill: "url(#dimple-shade)",
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 508,
    r: 8.5,
    fill: "url(#dimple-shade)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 538,
    cy: 523,
    r: 8.5,
    fill: "url(#dimple-shade)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 538,
    cy: 553,
    r: 8.5,
    fill: "url(#dimple-shade)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 568,
    r: 8.5,
    fill: "url(#dimple-shade)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486,
    cy: 553,
    r: 8.5,
    fill: "url(#dimple-shade)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486,
    cy: 523,
    r: 8.5,
    fill: "url(#dimple-shade)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 481,
    r: 8,
    fill: "url(#dimple-shade)",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 541,
    cy: 489,
    r: 8,
    fill: "url(#dimple-shade)",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561,
    cy: 510,
    r: 8,
    fill: "url(#dimple-shade)",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 538,
    r: 8,
    fill: "url(#dimple-shade)",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561,
    cy: 566,
    r: 8,
    fill: "url(#dimple-shade)",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 541,
    cy: 587,
    r: 8,
    fill: "url(#dimple-shade)",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 595,
    r: 8,
    fill: "url(#dimple-shade)",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483,
    cy: 587,
    r: 8,
    fill: "url(#dimple-shade)",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463,
    cy: 566,
    r: 8,
    fill: "url(#dimple-shade)",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455,
    cy: 538,
    r: 8,
    fill: "url(#dimple-shade)",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463,
    cy: 510,
    r: 8,
    fill: "url(#dimple-shade)",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483,
    cy: 489,
    r: 8,
    fill: "url(#dimple-shade)",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 456,
    r: 7.5,
    fill: "url(#dimple-shade)",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 548,
    cy: 464,
    r: 7.5,
    fill: "url(#dimple-shade)",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 487,
    r: 7.5,
    fill: "url(#dimple-shade)",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 592,
    cy: 520,
    r: 7.5,
    fill: "url(#dimple-shade)",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 592,
    cy: 556,
    r: 7.5,
    fill: "url(#dimple-shade)",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 589,
    r: 7.5,
    fill: "url(#dimple-shade)",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 548,
    cy: 612,
    r: 7.5,
    fill: "url(#dimple-shade)",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 620,
    r: 7.5,
    fill: "url(#dimple-shade)",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476,
    cy: 612,
    r: 7.5,
    fill: "url(#dimple-shade)",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 448,
    cy: 589,
    r: 7.5,
    fill: "url(#dimple-shade)",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 556,
    r: 7.5,
    fill: "url(#dimple-shade)",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 520,
    r: 7.5,
    fill: "url(#dimple-shade)",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 448,
    cy: 487,
    r: 7.5,
    fill: "url(#dimple-shade)",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476,
    cy: 464,
    r: 7.5,
    fill: "url(#dimple-shade)",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 487,
    cy: 510,
    rx: 26,
    ry: 20,
    fill: "white",
    opacity: 0.58
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNeuroiq);
export default __webpack_public_path__ + "static/media/icon-neuroiq.1f1494ad247a3a8cd16ef05464dd3bcd.svg";
export { ForwardRef as ReactComponent };